<template>
  <div id="app">

    <form :action="formAction" method="post">

      <div class="panel product-selection has--border is--rounded">
        <div class="panel--body is--wide">

          <div class="product-selector-wrapper">

            <h2 v-text="getTranlation('headlineChooseProduct')"></h2>

            <div class="product-selector">
              <div class="product" v-for="product in products" @click="setCurrentProduct(product)"
                   v-bind:class="{current: product == currentProduct}">

                <p class="product-name">{{ product.name }}</p>
                <img v-if="product.images[0]" :src="assetProduct(product, 0)">
                <div class="ok"><i class="icon--check"></i></div>

              </div>
            </div>


          </div>
        </div>
      </div>


      <div class="panel product-information has--border is--rounded" v-if="currentProduct">

        <div class="panel--title">
          <h2 v-text="currentSelection"></h2>
        </div>

        <div class="panel--body is--wide">

          <div class="current-product">
            <img v-if="currentProduct.images[1]" :src="assetProduct(currentProduct, 1)">
          </div>

          <div class="product-dimensions">
            <div class="subsettings-block">
              <h3 v-text="getTranlation('headlineDimensions')">Abmessungen</h3>
              <div class="input-number">
                <span class="help" v-text="getTranlation('headlineDimensionsL')"></span>
                <input name="l" type="number" size="10" v-model="formdata.l"
                       v-bind:min="currentProduct.dimensions.min.l"
                       :placeholder="getTranlation('headlineDimensionsL') + ' (mm)'">
                <span class="info">
                  <span class="icon--info"></span>
                  min: {{ currentProduct.dimensions.min.l }} mm
                </span>
              </div>
              <div class="input-number">
                <span class="help" v-text="getTranlation('headlineDimensionsB')"></span>
                <input name="b" type="number" size="10" v-model="formdata.b"
                       v-bind:min="currentProduct.dimensions.min.b"
                       :placeholder="getTranlation('headlineDimensionsB') + ' (mm)'">
                <span class="info">
                  <span class="icon--info"></span>
                  min: {{ currentProduct.dimensions.min.b }} mm
                </span>
              </div>
              <div class="input-number">
                <span class="help" v-text="getTranlation('headlineDimensionsH')"></span>
                <input name="h" type="number" size="10" v-model="formdata.h"
                       v-bind:min="currentProduct.dimensions.min.h"
                       :placeholder="getTranlation('headlineDimensionsH') + ' (mm)'">
                <span class="info">
                  <span class="icon--info"></span>
                  min: {{ currentProduct.dimensions.min.h }} mm
                </span>
              </div>
            </div>

            <div class="subsettings-block">
              <h3 v-text="getTranlation('headlineQuantity')"></h3>
              <div class="input-number">
                <input name="quantity" type="number" size="10" v-model="formdata.qty" min="150" step="50">
              </div>
            </div>

          </div>

          <div class="product-quality">
            <div class="subsettings-block">
              <h3 v-text="getTranlation('headlineQuality')"></h3>
              <select name="quality" v-model="currentQuality">
                <optgroup v-for="qualityGroup in qualities" v-bind:label="qualityGroup.name">
                  <option v-for="q in qualityGroup.content" :value="q" v-text="q"></option>
                </optgroup>
              </select>
            </div>

            <div class="subsettings-block">
              <h3 v-text="getTranlation('headlineColor')"></h3>
              <label v-for="color in colors" style="display: block">
                <input type="radio" name="currentColor" :value="color" v-model="currentColor"> {{ color }}
              </label>
            </div>

            <div class="subsettings-block">
              <h3 v-text="getTranlation('headlinePrint')"></h3>
              <select name="print" v-model="currentPrint">
                <option v-for="print in prints" :value="print" v-text="print"></option>
              </select>
            </div>

          </div>

        </div>
      </div>


      <div class="panel product-summary has--border is--rounded" v-if="currentProduct">

        <div class="panel--title">
        </div>
        <h2 v-text="getTranlation('headlineContact')"></h2>

        <div class="panel--body is--wide">
          <div class="product-summary-table">
            <table>
              <tr v-if="currentProduct">
                <th v-text="getTranlation('headlineChoosenProduct')">Produkt</th>
                <td v-text="currentProduct.name"></td>
              </tr>
              <tr v-if="currentDimension">
                <th v-text="getTranlation('headlineDimensions')">Abmessungen</th>
                <td v-text="currentDimension"></td>
              </tr>
              <tr v-if="currentPrint">
                <th v-text="getTranlation('headlinePrint')">Bedruckung</th>
                <td v-text="currentPrint"></td>
              </tr>
              <tr v-if="currentQuality">
                <th v-text="getTranlation('headlineQuality')">Qualität</th>
                <td v-text="currentQuality"></td>
              </tr>
              <tr v-if="currentColor">
                <th v-text="getTranlation('headlineColor')">Farbe</th>
                <td v-text="currentColor"></td>
              </tr>
              <tr v-if="formdata.qty">
                <th v-text="getTranlation('headlineQuantity')">Menge</th>
                <td v-text="formdata.qty"></td>
              </tr>
            </table>
          </div>

          <div class="contact-form">
            <input name="name" class="input-field" type="text" v-model="formdata.name" required
                   :placeholder="getTranlation('formName')">
            <input name="tel" class="input-field" type="tel" v-model="formdata.tel" required
                   :placeholder="getTranlation('formTel')">
            <input name="email" class="input-field" type="email" v-model="formdata.email" required
                   :placeholder="getTranlation('formEmail')">
            <input name="company" class="input-field" type="text" v-model="formdata.company"
                   :placeholder="getTranlation('formCompany')">
            <textarea class="input-field" name="deliveryAddress" cols="30" rows="3" v-model="formdata.deliveryAddress"
                      :placeholder="getTranlation('formDelivery')"></textarea>
            <textarea class="input-field" name="comment" cols="30" rows="4" v-model="formdata.comment"
                      :placeholder="getTranlation('formComments')"></textarea>
            <p>

              <label>
                <input type="checkbox" required="required" v-model="acceptDSGVO" name="dsgvo"
                       style="float: left; margin-top: 5px; margin-right: 5px;">
                {{ getTranlation('formPrivacy1') }}
                <a v-on:click.stop="openFuckingModal" :title="getTranlation('formPrivacy2')">
                  {{ getTranlation('formPrivacy2') }}
                </a> {{ getTranlation('formPrivacy3') }}.
              </label>

            </p>
            <input type="submit" @click="sendForm" :value="getTranlation('formSend')" class="btn btn-primary">
          </div>
        </div>

      </div>

      <!--hidden fields for information not directly in form components-->
      <input type="hidden" name="product" v-if="currentProduct" v-model="currentProduct.name">


    </form>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'App',
  data: function () {
    return {
      currentProduct: null,
      currentPrint: null,
      currentQuality: null,
      currentColor: null,
      formdata: {
        l: '',
        b: '',
        h: '',
        qty: 150
      },
      products: [],
      prints: [],
      qualities: [],
      colors: [],
      acceptDSGVO: false,
      translations: []
    }
  },
  computed: {
    currentSelection() {
      let text = '';

      if (this.currentProduct)
        text = this.getTranlation('headlineChoosenProduct') + ': ' + this.currentProduct.name;

      return text;
    },
    currentDimension() {
      if (!this.formdata.l || !this.formdata.b || !this.formdata.h)
        return false;

      return this.formdata.l + ' x ' + this.formdata.b + ' x ' + this.formdata.l + ' (LxBxH)';
    },
    formAction() {
      return window.baseUrl + '/t10CartonContact/sendMail'
    }
  },
  created() {

    axios.get('/t10CartonContact/getSnippets', {
      params: {
        shopId: window.shopId
      }
    })
      .then(response => {
        this.translations = response.data.data
      })

    axios.get('/t10CartonContact/getProducts')
      .then(response => {
        this.products = response.data.products;
        this.setCurrentProduct(this.products[0]);
      });

    axios.get(window.baseUrl + '/t10CartonContact/getPrints')
      .then(response => {
        this.prints = response.data.prints;
        this.setCurrentPrint(this.prints[0]);
      });

    axios.get(window.baseUrl + '/t10CartonContact/getQualities')
      .then(response => {
        this.qualities = response.data.qualities;
      });


    axios.get(window.baseUrl + '/t10CartonContact/getColors')
      .then(response => {
        this.colors = response.data.colors;
        this.setCurrentColor(this.colors[0]);
      });


  },
  methods: {
    getTranlation(key) {
      let x = this.translations.find(item => item.key === key)
      return (x !== undefined) ? x.value : key
    },
    openFuckingModal() {

      window.$.modal.open(this.getTranlation('formPrivacyLink'), {'mode': 'ajax'});
      return false;
    },
    sendForm() {
      if (!this.acceptDSGVO)
        return false;
    },
    assetProduct(product, nr = 0) {
      if (!product.images[nr])
        return false;

      return require('./assets/products/' + product.images[nr]);
    },
    assetPrint(print) {
      if (!print.img1)
        return false;

      return require('./assets/prints/' + print.img1);
    },
    setCurrentProduct(product) {
      if (product && this.currentProduct !== product)
        this.currentProduct = product;

    },
    setCurrentPrint(print) {
      if (print && this.currentPrint !== print)
        this.currentPrint = print;

    },
    setCurrentColor(color) {
      if (color && this.currentColor !== color)
        this.currentColor = color;
    },
    setCurrentQuality(quality) {
      if (quality && this.currentQuality !== quality)
        this.currentQuality = quality;
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/App.vue